import React, { useState, useEffect } from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight, } from "react-icons/md";

import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import { ActionFormatterComponent, statusActiveFormatterDevices } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import AdminHeader from "../../../components/CommonComponents/AdminHeader";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import { toast } from "react-toastify";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { capsFirstLetter } from "../../../components/CommonMethod/CommonMethods";
import { BiTask } from "react-icons/bi";

function SubscriptionPlan() {
  const labelSource = 'subscription-plan'
  const headers = getItemToken('access_token')
  const BaseUrl = process.env.REACT_APP_Baseurl
  const listApi = `${BaseUrl}/admin/subscription/index`
  const multiDelete = `${BaseUrl}/admin/subscription/multi-delete`
  const labelApi = `${BaseUrl}/admin/Label-Management/list-source?source=${labelSource}`
  const userAccessToken = getItemToken('access_token');

  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [modelClose, setModelClose] = useState(false);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [labelDisplay, setLabelDisplay] = useState([]);
  const statusToggleApi = `${BaseUrl}/admin/subscription/status-toggle`;
  const planBasedVideoToggleApi = `${BaseUrl}/admin/subscription/plan-based-video-toggle`;


  const planFormatter = (data, row) => {
    return (
      <div className="d-flex justify-content-between align-items-center">
        <div className="rightVideoTitle">
          <p className="table-heading">{data}</p>
          <span className="dateText table-subheading theme-text-color">{row?.upload_on}</span>
        </div>
      </div>
    );
  };

  const handleStatusToggle = async (row) => {
    const newStatus = row?.status == 1 ? 0 : 1;
    try {
      await axios.post(statusToggleApi, { group_plan_id: row?.group_plan_id, status: newStatus }, { headers });
      // update local state without full reload
      const updater = (list) =>
        list.map((item) =>
          item?.group_plan_id === row?.group_plan_id ? { ...item, status: newStatus } : item
        );
      setApiData((prev) => updater(prev));
      setFilteredData((prev) => updater(prev));
    } catch (err) {
      toast.error(err?.response?.data?.message || "Status update failed");
    }
  };

  const handlePlanBasedVideoToggle = async (row) => {
    const newValue = row?.plan_based_video == 1 ? 0 : 1;
    try {
      await axios.post(planBasedVideoToggleApi, { group_plan_id: row?.group_plan_id, plan_based_video: newValue }, { headers });
      const updater = (list) =>
        list.map((item) =>
          item?.group_plan_id === row?.group_plan_id ? { ...item, plan_based_video: newValue } : item
        );
      setApiData((prev) => updater(prev));
      setFilteredData((prev) => updater(prev));
    } catch (err) {
      toast.error(err?.response?.data?.message || "Plan based video update failed");
    }
  };

  const statusColumnFormatter = (cell, row) => (
    <div className="d-flex flex-column align-items-center gap-2">
      {statusActiveFormatterDevices(cell, row)}
      <AdminSwitch
        name="status"
        checked={cell == 1}
        onChange={() => handleStatusToggle(row)}
      />
    </div>
  );

  const planBasedVideoColumnFormatter = (cell, row) => (
    <div className="d-flex flex-column align-items-center gap-2">
      {statusActiveFormatterDevices(cell, row)}
      <AdminSwitch
        name="plan_based_video"
        checked={cell == 1}
        onChange={() => handlePlanBasedVideoToggle(row)}
      />
    </div>
  );

  const columns = [
    {
      dataField: "sno",
      text: "S.No",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      headerStyle: { width: "50px", textAlign: "center" },
      style: { textAlign: "center" },
      isDummyField: true,
      colStyle: "text-nowrap",
    },
    {
      dataField: "plans_name",
      text: "Plan Name",
      formatter: (cell, row) => planFormatter(cell, row),
      headerClasses: 'video-width-table'
    },
    {
      dataField: "billing_interval",
      text: "Interval",
      formatter: (cell, row) => <span className="">{capsFirstLetter(cell)}</span>,
    },
    {
      dataField: "price",
      text: "Price",
    },
    {
      dataField: "currency",
      text: "Currency",
      formatter: (cell) => <span className="">{cell || '-'}</span>,
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => statusColumnFormatter(cell, row),
    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) => <ActionFormatterComponent cell={cell} row={row} previewlink={`/preview-subscription-plan/${row?.group_plan_id}`} action={singleDelete} hideEditNavigation PreviewNavigation />,
    },
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 4,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [{
      text: '5', value: 5
    }, {
      text: '10', value: 10
    }, {
      text: 'All', value: Number(filteredData?.length)
    }]
  };

  // const selectRow = {
  //   mode: "checkbox",
  //   onSelect: (row, isSelect) => {
  //     if (row) {
  //       if (isSelect) {
  //         setItemToDelete([...itemToDelete, row.id]);
  //       } else {
  //         setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
  //       }
  //     }
  //   },
  //   style: { width: '30px' },
  //   selected: itemToDelete,
  //   selectionHeaderRenderer: ({ mode, checked }) => (
  //     <div>
  //       <input type="checkbox" checked={checked} onChange={handleAll} />
  //     </div>
  //   ),
  // };

  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: headers });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err.response.data.message)

    }
  }

  const fetchData = async () => {

    try {
      const response = await axios.get(`${listApi}`, { headers: headers });
      const result = response?.data?.AllSubscriptionPlan;
      setApiData(result);
      setFilteredData(result);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    try {
      const response = await axios.post(`${multiDelete}`, { id: [...itemToDelete] }, { headers: userAccessToken }
      );
      const result = response?.data;
      if (result?.status) {
        setWithOutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setItemToDelete([])
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };

  const reloadAction = () => {
    setWithOutRefresh(prev => !prev)
  }

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  // const handleAll = () => {
  //   setSelectAll(!selectAll);
  //   setItemToDelete(selectAll ? [] : filteredData?.map((item) => item?.id));
  // };

  const handleFilterChange = (data) => {
    setFilteredData(data);
  };


  useEffect(async () => {
    await fetchData();
    await labelFetch()
  }, [withOutRefresh]);

  return (
    <>
      {modelClose && <AdminDeleteModal modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={itemToDelete?.length} />}
      <AdminNavbar heading={labelDisplay?.[0]?.title} totalDataLength={apiData?.length} deleteCount={0} navigation={"/add-subscription-plans"} deleteMethod={openModal} navText={labelDisplay?.[2]?.title} />
      <div className="theme-bg-color p-3 rounded-2 bootstrapTable  multi-delete-width" >
        <AdminHeader hideExport searchMethod={handleFilterChange} reload={true} reloadAction={reloadAction} loading={loading} reduceData={filteredData} originalData={apiData} fileName={"SUBSCRIPTION-PLANS-LIST"} customSubscriptionPlan />
        <BootstrapTable keyField="id" pagination={paginationFactory(options)} columns={columns} data={filteredData} className="no-border-table theme-text-color " noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />} hover headerClasses="videoWidth" />
        {/* selectRow={selectRow} selectAll={selectAll} */}
      </div>
    </>
  );
}

export default SubscriptionPlan;